var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FEE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2543 12.8884L12.1824 31.372C11.9541 31.7674 11.8333 32.2156 11.832 32.6721C11.8308 33.1286 11.949 33.5774 12.1751 33.974C12.4012 34.3706 12.7271 34.7011 13.1206 34.9326C13.514 35.1641 13.9612 35.2886 14.4177 35.2936H36.5615C37.0179 35.2886 37.4651 35.1641 37.8586 34.9326C38.252 34.7011 38.578 34.3706 38.804 33.974C39.0301 33.5774 39.1484 33.1286 39.1471 32.6721C39.1458 32.2156 39.025 31.7674 38.7968 31.372L27.7249 12.8884C27.4918 12.5042 27.1637 12.1866 26.7722 11.9661C26.3806 11.7457 25.9389 11.6299 25.4896 11.6299C25.0402 11.6299 24.5985 11.7457 24.207 11.9661C23.8154 12.1866 23.4873 12.5042 23.2543 12.8884V12.8884Z",
    stroke: "#DC2828",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4902 19.6074V24.8362",
    stroke: "#DC2828",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4902 30.0654H25.5031",
    stroke: "#DC2828",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.dd2b3a9aaa1734fb0904de4ce72e644f.svg";
export { ForwardRef as ReactComponent };